import React, { useState } from "react";
import SingleUrlValidator from "./SingleUrlValidator";
import MultipleUrlValidator from "./MultipleUrlValidator";
import * as XLSX from "xlsx";
import axios from "axios";
import moment from "moment";

export default function ImageValidator({
  showModal,
  handleCloseModal,
  handleSingleUrl,
  handleMultipleUrl,
  btnShow,
}) {
  //==========================multiple validator ============================//
  const [results, setResults] = useState([]);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMultipleValidaotr, setErrorMultipleValidaotr] = useState("");

  //==========================single validator ============================//

  const [imageValidatorUrl, setImageValidatorUrl] = useState("");
  const [loadingImageData, setLoadingImageData] = useState(false);
  const [errorSingleValidaotr, setErrorSingleValidaotr] = useState("");
  const [imageValidationData, setImageValidationData] = useState({
    pathFile: "",
    exist: null, // Initialize as null
    imageUrl: "",
    message: "",
  });

  //==========================multiple validator ============================//
  const handleFileChange = (event) => setFile(event.target.files[0])

  const handleSubmit = async () => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }

    setLoading(true);
    setErrorMultipleValidaotr("");

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

      const urls = json
        .flat()
        .filter(
          (url) =>
            url && typeof url === "string" && url.trim().startsWith("http")
        )
        .map((url) => ({ url: url.trim() }));

      const apiUrl = "https://images.kgkdms.com/damImage/pathValidation";


      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(urls),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const resultsData = await response.json();

        setResults(resultsData);
      } catch (apiError) {
        errorMultipleValidaotr("Error occurred while calling the API");
        console.error("API Error:", apiError);
      } finally {
        setLoading(false);
      }
    };

    reader.readAsArrayBuffer(file);
  };


  const handleResetEncryption = () => {
    setFile(null);
    setResults([]);
    setErrorMultipleValidaotr("");
    document.getElementById("formFileSm").value = null;
  }

  //==========================single validator ============================//

  const handleSingleSubmit = async () => {
    setErrorSingleValidaotr(""); // Reset error message
    try {
      setLoadingImageData(true);

      // Send the image URL for validation
      const response = await axios.post(
        "https://images.kgkdms.com/damImage/pathValidation",
        [{ url: imageValidatorUrl }]
      );

      const validationData = response.data[0];
      const path = validationData.filePath?.split("eisdam")[1];

      // Update the state with new data
      setImageValidationData({
        pathFile: validationData.filePath || validationData.url,
        exist: validationData.isExists,
        imageUrl: `https://images.kgkdms.com/damImage/actualImg?imgUrl=${path}`,
        message: validationData.message || "",
      });
    } catch (error) {
      console.error("Error fetching validation data:", error);
      setErrorSingleValidaotr("An error occurred while validating the URL."); // Set error message
    } finally {
      setLoadingImageData(false);
    }
  };

  const handleChangeUrl = (e) => setImageValidatorUrl(e.target.value)

  const handleResetPath = () => {
    setImageValidatorUrl("")
    setImageValidationData({
      pathFile: "",
      exist: null,
      imageUrl: "",
      message: "",
    });
  };


  const onHandleDownload = () => {
    const ws = XLSX.utils.json_to_sheet(results);

    const timestamp = moment().format("YYYY_MMMM_Do_h-mm-ss-a");
    const fileName = `${file.name.split(".")[0]}_${timestamp}.xlsx`;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    // Write the Excel file
    XLSX.writeFile(wb, fileName);
  };

  return (
    <>
      <div
        className={`modal fade show`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden={!showModal}
      >
        <div className="modal-fullscreen" style={{ height: "100%" }}>
          <div className="modal-content" style={{ height: "100%" }}>
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Image Validator
              </h1>
              <div className="d-flex justify-content-end">
                <div
                  className="btn-group mr-2"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSingleUrl}
                    disabled={btnShow === true}
                  >
                    Single Url Validator
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleMultipleUrl}
                    disabled={btnShow === false}
                  >
                    Multiple Url Validator
                  </button>
                </div>
                <button
                  type="button ml-2"
                  className="btn btn-outline-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
            <div className="modal-custom-body">
              {btnShow ? (
                <SingleUrlValidator
                  handleReset={handleResetPath}
                  imageValidatorUrl={imageValidatorUrl}
                  handleChangeUrl={handleChangeUrl}
                  loadingImageData={loadingImageData}
                  handleClose={loadingImageData}
                  imageValidationData={imageValidationData}
                  handleSingleSubmit={handleSingleSubmit}
                  errorSingleValidaotr={errorSingleValidaotr}
                />
              ) : (
                <MultipleUrlValidator
                  results={results}
                  setResults={setResults}
                  handleSubmit={handleSubmit}
                  handleFileChange={handleFileChange}
                  handleResetEncryption={handleResetEncryption}
                  error={errorMultipleValidaotr}
                  loading={loading}
                  file={file}
                  onHandleDownload={onHandleDownload}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
